export const PAGE_NAMES = {
  expenses: "Expenses", policies: "Policies", communications: "Communications",
  employees: "Employees", integrations: "Integrations", settings: "Settings",
};

const BASE_SUGGESTIONS = ["Who has outstanding violations?", "Who are the top spenders?"];

const PAGE_SUGGESTIONS = {
  expenses: ["Auto-approve all the clean expenses", "Show me expenses that need review", "Remind everyone with missing receipts"],
  policies: ["Show me the most violated policies", "Who has outstanding violations?"],
  communications: ["Remind everyone with missing receipts", "Who owes receipts?"],
  employees: ["Who are the top spenders?", "Remind everyone with missing receipts"],
};

export const suggestionsFor = (pageKey) =>
  [...new Set([...(PAGE_SUGGESTIONS[pageKey] || []), ...BASE_SUGGESTIONS])].slice(0, 4);
